export default "__VITE_ASSET__B9V_duxb__"